import { ApolloClient, Reference } from '@apollo/client';

export const removeBookmarkFromCache = (
  removedBookmarkId: string,
  client: ApolloClient<object>
) => {
  client.cache.modify({
    fields: {
      bookmarks(existing, { readField }) {
        return existing.filter(
          (item: Reference & { item: Reference }) =>
            readField('id', item.item) !== removedBookmarkId
        );
      }
    },
    broadcast: true
  });
};

export const addBookmarkToCache = (
  itemId: string,
  client: ApolloClient<object>
) => {
  client.cache.modify({
    fields: {
      bookmarks(existing = [], { toReference, readField }) {
        const alreadyExists = existing.some(
          (bookmark: Reference & { item: Reference }) =>
            readField('id', bookmark.item) === itemId
        );
        if (alreadyExists) return existing;
        return [
          ...existing,
          {
            __typename: 'Bookmark',
            item: toReference({ __typename: 'Item', id: itemId })
          }
        ];
      }
    },
    broadcast: true
  });
};
